import { styled } from "../stitches.config";

export const Sup = styled("sup", {
  fontFeatureSettings: '"sups"',
  fontSize: "100%",
  lineHeight: "1",
  verticalAlign: "baseline",
});
